import styled from "styled-components";

export const AboutUserWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: 280px;
  width: 100%;
  height: auto;
`;
